export default "__VITE_ASSET__bfc02651__"